module.exports = __webpack_public_path__ + "img/logo.eb2fb2f1.svg";